/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Αποκτήστε συνημμένα'
  },
  HEADER: {
    DATE: 'Ημερομηνία',
    SENT_BY_F: 'Υποβλήθηκε από',
    TITLE: 'Τίτλος'
  },
  LABEL: {
    ATTACHMENTS: 'Παραρτήματα',
    DATE: 'Ημερομηνία',
    DETAIL: 'Λεπτομέρειες',
    MESSAGE: 'Μήνυμα',
    NO_ROWS_COMMUNICATIONS: 'Καμία επικοινωνία',
    SENT_BY_F: 'Υποβλήθηκε από',
    TITLE: 'Τίτλος',
    UNREAD: 'Unread'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
